export const mapValues = (fieldsData) => {
  return Object.keys(fieldsData).reduce((values, name) => {
    return Object.assign(values, { [name]: fieldsData[name].value })
  }, {})
}



// WEBPACK FOOTER //
// ./src/lib/form/utils.js